import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Exercise } from '../../../../config/api/models/Exercise';
import { Icons, ltiSettingsByType } from '../../../shared/components';
import { StyledIconButton } from './Atoms';

type ExerciseTitleBarEditActionsProps = {
  exercise: Exercise;
  mode: 'read' | 'edit';
  onDeleteExercise?: () => void;
  onUpdateExercise?: () => void;
  onDuplicateExercise?: () => void;
  hideDeleteButton?: boolean;
};

export const ExerciseTitleBarEditActions: FC<ExerciseTitleBarEditActionsProps> = ({
  exercise,
  mode,
  onDeleteExercise,
  onUpdateExercise,
  onDuplicateExercise,
  hideDeleteButton,
}) => {
  const { t } = useTranslation();

  return mode === 'edit' ? (
    <>
      <StyledIconButton
        icon={Icons.EDIT}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          !!onUpdateExercise && onUpdateExercise();
        }}
        tooltip={t('shared.edit')}
      />
      {ltiSettingsByType[exercise.type]?.duplicationApiRoute != null && exercise.url != null && (
        <StyledIconButton
          icon={Icons.DUPLICATE}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            !!onDuplicateExercise && onDuplicateExercise();
          }}
          tooltip={t('shared.duplicate')}
        />
      )}
      {!hideDeleteButton && (
        <StyledIconButton
          icon={Icons.DELETE}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            !!onDeleteExercise && onDeleteExercise();
          }}
          tooltip={t('shared.delete')}
        />
      )}
    </>
  ) : null;
};
